import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  isMobileMenuOpen = false;
  expandedMobileMenu: string | null = null;

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  toggleSubmenu(menu: string): void {
    this.expandedMobileMenu = this.expandedMobileMenu === menu ? null : menu;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.expandedMobileMenu = null;
  }
}
